<div class="container-fluid p-2 m-0">
 
    <div class="row w-100 m-0 p-1 bg-white shadow">
        <div class=" title-header w-100"><h5 class="m-0 p-0">profile</h5>
        </div>


        <div class="col-lg-8 m-0 p-4">
            <div class="row">
                <div class="col-md-7 m-0 p-0">
                    <h4  class="card-title">Personal Information</h4>
                    <div class="">
                        <table  class="profile_info table table-borderless table-nowrap">
                            <tbody >
                                <tr>
                                    <td class=""><p  class="mb-0 text-uppercase">First Name :</p></td>
                                    <td><p  class=" mb-0">{{first_name}}</p>  </td>              
                                </tr>
                                <tr>
                                    <td> <p class="mb-0 text-uppercase">Last Name :</p></td>
                                    <td><p  class="mb-0">{{last_name}}</p></td>
                                </tr>
                                <tr>
                                    <td><p  class="mb-0 text-uppercase">Email :</p></td>
                                    <td> <p  class="mb-0">{{email}}</p> </td>
                                </tr>
                                <tr>
                                    <td> <p  class="mb-0 text-uppercase">Phone Number :</p> </td>
                                    <td> <p  class="mb-0">{{mobile}}</p> </td>
                                </tr>
                                <tr>
                                    <td><p  class="mb-0 text-uppercase">Region :</p> </td>
                                    <td> <p  class="mb-0">{{region_name}}</p> </td>
                                </tr>
                                <tr>
                                    <td><p  class="mb-0 text-uppercase">Showroom :</p> </td>
                                    <td> <p  class="mb-0">{{showroom_name}}</p></td>
                                </tr>
                                <tr>
                                    <td> <p  class="mb-0 text-uppercase">designation :</p></td>
                                    <td> <p  class="mb-0">{{role_name}}</p> </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  
                </div>
                <div class="col-md-5 my-auto m-0 p-0">
                    <div class="profile_image">
                        <img alt="" onerror="this.src='/assets/images/faces/dummy.png'"  src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{profile_picture}}"  class="img-thumbnail-lg avatar-lg">
                    </div>
                </div>
            </div>
           
        </div>
        <div class="col-lg-4 m-0 p-1">
         
        </div>

        
    </div>   
</div>